export enum DocumentStatus {
    PENDING = 'pending',
    DONE = 'done'
}
